import { getLayoutObjFromName } from './getLayoutObjFromName';

export const getRatio = (settings) => {
  const {
    gridImageRatio,
    thumbnailsImageRatio,
    sliderImageRatio,
    carouselImageRatio,
    layout
  } = settings;
  const { type, view } = getLayoutObjFromName(layout);
  let result = null;

  if (type === 'masonry' && view === 'grid') result = gridImageRatio;
  if (type === 'thumbnails') result = thumbnailsImageRatio;
  if (type === 'slider') result = sliderImageRatio;
  if (type === 'carousel') result = carouselImageRatio;

  return result;
};
